<template>
  <div class="bill-list-circle">
    <el-table :data="billList">
      <el-table-column label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
      <el-table-column label="币种" prop="txCoin"></el-table-column>
      <el-table-column label="用户Id" prop="userId"></el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.txType === -1">提现</span>
          <span v-else-if="scope.row.txType === -2">内部地址提现</span>
          <span v-else>充值</span>
        </template>
      </el-table-column>
      <el-table-column label="hash">
        <template slot-scope="scope">
          <span class="textover">
            <a :href="`${scope.row.hashAddressLink}`" target="_blank">{{
              scope.row.txNetworkId
            }}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="txAmount"></el-table-column>
      <el-table-column label="手续费" prop="txFee"></el-table-column>
      <el-table-column label="From">
        <template slot-scope="scope">
          <span class="textover">
            <a :href="`${scope.row.fromAddressLink}`" target="_blank">{{
              scope.row.txFromWallet
            }}</a>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="To">
        <template slot-scope="scope">
          <span class="textover">
            <a :href="`${scope.row.toAddressLink}`" target="_blank">{{
              scope.row.txToWallet
            }}</a>
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="内部状态" prop="txSattusInner"></el-table-column> -->
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="recharge(scope.row.id)"
            >充值确认</el-button
          >
          <el-button type="danger" size="small" @click="reset(scope.row.id)"
            >充值重置</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState('abnormal', ['billList', 'pagination', 'totalCount'])
  },
  methods: {
    ...mapMutations('abnormal', ['setpage']),
    ...mapActions('abnormal', ['getUserBillList', 'reRecharge', 'reReset']),
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    },
    recharge(id) {
      this.$confirm('确认要进行充值确认吗？', '提示', { type: 'warning' }).then(
        () => {
          this.reRecharge({ id: id }).then(() => {
            this.$message.success('确认成功！');
            this.$emit('refresh', this.pagination);
          });
        }
      );
    },
    reset(id) {
      this.$confirm('确认要进行充值重置吗？', '提示', { type: 'warning' }).then(
        () => {
          this.reReset({ id: id }).then(() => {
            this.$message.success('重置成功！');
            this.$emit('refresh', this.pagination);
          });
        }
      );
    }
  },
  components: {
    Pagination
  }
};
</script>
<style>
.textover {
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
